export default __webpack_public_path__ + "static/media/629.d7e3d878.png";